var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorstation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08_\u533B\u751F\u5DE5\u4F5C\u7AD9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3,8H6.3a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2h52a2,2,0,0,0,2-2V10A2,2,0,0,0,58.3,8Zm-2,4V24H8.3V12ZM8.3,52V28h48V52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.56,37h-12a2,2,0,0,0-1.84,1.16l-1.59,3.54-5-8.66A2.1,2.1,0,0,0,23,32.58l-5.74,5.74a1.94,1.94,0,0,0,0,2.75l.08.08a2,2,0,0,0,2.75,0L24,37.24l5.68,9.85a2,2,0,0,0,2.66.71l.1-.06,0,0,.11-.08.21-.15h0a1.74,1.74,0,0,0,.45-.63L35.84,41H46.56A2,2,0,0,0,48.51,39v-.11A2,2,0,0,0,46.56,37Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.32,
    cy: 18.02,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 18.02,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.29,
    cy: 18.02,
    r: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorstation);
export default __webpack_public_path__ + "static/media/doctorstation.9b875c86.svg";
export { ForwardRef as ReactComponent };